import ScrollReveal from 'scrollreveal'

class Reveal {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            distance: '50px',
            origin: 'bottom',
            delay: 200,
            duration: 1500,
            easting: 'ease-in-out',
            opacity: 0,
            reset: false,
            showAbove: null,
            showBelow: null
        }, JSON.parse(this.elem.dataset.reveal ? this.elem.dataset.reveal : '{}'))
    }

    onInit () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            this.elem.removeAttribute('data-reveal')
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            this.elem.removeAttribute('data-reveal')
            return false
        }
        ScrollReveal().reveal(this.elem, this.options)

        document.addEventListener('updateScrollReveal', () => {
            ScrollReveal().sync()
        })
    }
}

export default Reveal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Reveal.js